import React from 'react';
import CMPImage from 'components/global/image';

const PetIcon: React.FunctionComponent = () => {
  const src = '/images/pet.png';
  return <CMPImage asset={{ src, alt: 'Character' }} width={16} height={18} />;
};
export default PetIcon;
